import React, { Component } from 'react'
import '../Calendar.css'
import { withStore } from '../store'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import 'simplebar/dist/simplebar.min.css'
import SearchInput from '../SearchInput'

class ServiceSideBar extends Component {
    static displayName = ServiceSideBar.name;

    constructor(props) {
        super(props);
        this.state = {
            serviceGroups: [],
            name: ''
        };
        this.simpleBarWrapperRef = null;
        this.serviceGroupDropDownRef = null;
        this.timeoutVar = null;

        this.onTextFilterChange = this.onTextFilterChange.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
    }

    componentWillMount() {
        this.setFilters();
    }

    setFilters() {
        let filters = this.props.filters;
        let initialName = '';
        let initialGroup = [];
        filters.splice(0, filters.length);
        filters.push({ name: "name", value: initialName });
        filters.push({ name: "serviceGroups", value: initialGroup });
        let initialState = {
            name: initialName,
            serviceGroup: initialGroup
        };
        this.setState(initialState);
        this.props.updateFilters(filters);
    }

    updateFilter(filterName, value) {
        let filters = this.props.filters;
        let element = filters.find(element => element.name === filterName);
        element.value = value;
        this.props.updateFilters(filters);
    }

    onTextFilterChange(filter, value) {
        clearTimeout(this.timeoutVar);
        let newState = this.state;
        newState[filter] = value;
        this.setState({ newState }, () => {
            this.timeoutVar = setTimeout(() => { this.updateFilter(filter, value) }, 500)
        });
    }

    render() {
        const serviceGroupFilter = this.props.filters.find(element => {
            if (element.name === 'serviceGroups'){return element}
        })

        return (
            <div style={{ "height": "100%" }} data-simplebar >
                <div className='mt-1 pl-1 pr-1 filters'>
                    <div className='flex-nowrap justify-space-between align-end mb-1'>
                        <h3>Filters</h3>
                        <button
                            className='round-button medium-round-button grey-outline-button pr-05 pl-05'
                            onClick={() => this.setFilters()}
                        >Clear Filters</button>
                    </div>

                    <p>Search:</p>
                    <SearchInput
                        placeholder='Search'
                        /*wrapperClassName = 'm-1'*/
                        value={this.state.name}
                        onValueChange={(value) => this.onTextFilterChange("name", value)}
                        onClearValueButtonClick={() => this.onTextFilterChange("name", "")}
                    />
                    <p>Service Groups:</p>
                <MultiDropDown 
                        ref={el => this.serviceGroupDropDownRef = el}
                        list={this.props.store.serviceGroups}
                    multiSelect={true}
                    keyProperty='id'
                    textProperty='name'
                    defaultValue={serviceGroupFilter ? serviceGroupFilter.value : [] }
                    placeholder='Service Group'
                    onDropDownValueChange = {value => this.updateFilter("serviceGroups", value)}
                />

                </div>
            </div>
        );
    }
}

export default withStore(ServiceSideBar);


// WEBPACK FOOTER //
// ./src/components/Service/ServiceSideBar.jsx